import { useState, useMemo } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import {
  useGetFooterMenusDataQuery,
  useGetMenusDataQuery,
} from "../../../redux/services/internal/apiHome";
import { flattenMenus } from "../../../Utility/FlattenMenu";
import { Link } from "react-router-dom";
import Loader from "./Loader";

const SearchComponent = ({ benchId }) => {
  const { data: fetchMenus = {}, isLoading: isMenuLoading } =
    useGetMenusDataQuery(benchId);
  const { data: fetchFooterMenus = {}, isLoading: isFooterMenuLoading } =
    useGetFooterMenusDataQuery(benchId);

  const combinedData = useMemo(() => {
    const menusData = fetchMenus.data ? flattenMenus(fetchMenus.data) : [];
    const footerMenusData = fetchFooterMenus.data
      ? flattenMenus(fetchFooterMenus.data)
      : [];
    return [...menusData, ...footerMenusData];
  }, [fetchMenus.data, fetchFooterMenus.data]);

  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
    setSearchTerm("");
  };

  const filteredResults = combinedData.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (isMenuLoading || isFooterMenuLoading) {
    return <Loader />;
  }

  return (
    <div className="search-container">
      <button className="search-icon" onClick={toggleSearch}>
        {isSearchOpen ? <FaTimes /> : <FaSearch />}
      </button>

      {isSearchOpen && (
        <div className="search-input-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
            autoFocus
          />

          {searchTerm && (
            <div className="search-results">
              <ul>
                {filteredResults.length > 0 ? (
                  filteredResults.map((item) => (
                    <li key={item.slug}>
                      <Link to={item.slug} onClick={() => setSearchTerm("")}>
                        {item.title}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No results found</li>
                )}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchComponent;
